import { Grid } from '@mui/material';
import { AuditDateTimeRangeFields } from '../../../../components/AuditDateTimeRangeFields';
import { MentionIdField } from '../../../../components/MentionIdField';

/**
 * Filter form for mentions matches listing.
 */
export function MentionsMatchesForm() {
  return (
    <div>
      <AuditDateTimeRangeFields />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4} lg={3} xl={2}>
          <MentionIdField name="name" />
        </Grid>
      </Grid>
    </div>
  );
}
